import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import game from '@/view/game'
import share from '@/view/share'


import { handleWeChatAuth } from '@/utils/wechat'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/game',
      name: '游戏页面',
      component: game
    },{
      path: '/',
      name: '首页',
      component: index
    },{
      path: '/share',
      name: '分享',
      component: share
    }
  ]
})
// 标记是否已完成微信授权
let weChatAuthResolved = false

// 路由前置守卫 —— 微信授权检查
router.beforeEach(async (to, from, next) => {
  // 如果已经完成过授权检查，直接放行

  if (weChatAuthResolved) {
    next()
    return
  }

  try {

    // 这里不拦截路由：handleWeChatAuth 内部会在需要时触发跳转；
    // 如果因后端报错被“冷却阻止重定向”，也应放行页面避免卡住/死循环。
    await handleWeChatAuth()
    weChatAuthResolved = true
    next()
  } catch (error) {
    console.error('微信授权检查异常', error)
    // 出错也放行，避免页面卡住
    weChatAuthResolved = true
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js